import { createLineDiscussionsAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/line_discussions.js?vue3';
import { createNoPreviewDiscussionsAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/no_preview_discussions.js?vue3';
import { commitDiffDiscussionsStore } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/instances/commit_discussions.js?vue3';
import { s__ } from '~/locale';

const discussionsErrorMessage = s__(
  'RapidDiffs|Some discussions for this file could not be displayed.',
);

export const commitInlineDiscussionsAdapter = createLineDiscussionsAdapter({
  store: commitDiffDiscussionsStore,
  parallel: false,
  errorMessage: discussionsErrorMessage,
});
export const commitParallelDiscussionsAdapter = createLineDiscussionsAdapter({
  store: commitDiffDiscussionsStore,
  parallel: true,
  errorMessage: discussionsErrorMessage,
});
export const commitNoPreviewDiscussionsAdapter = createNoPreviewDiscussionsAdapter(
  commitDiffDiscussionsStore,
);
